import { del, get, post, postFormData, put } from './api.service';

const base_url = 'customers/v1';

export const getAll = (params: {
        page?: number,
        per_page?: number,
        search?: string,
        status?: string,
        order?: string
} = {}) => {
    const queryString = Object.keys(params)
        .filter(key => params[key as keyof typeof params])
        .map(key => {
            return `${key}=${params[key as keyof typeof params]}`;
        }).join('&');

    let url = queryString ? base_url + `?${queryString}` : base_url;

    return get(url);
}

export const getById = (id: string) => {
    return get(`${base_url}/${id}`);
}

export const create = (data: object) => {
    return post(base_url, data);
}

export const update = (data: { values: object, id: string }) => {
    return put(`${base_url}/${data.id}`, data.values);
}

export const remove = (id: string | undefined) => {
    return del(`${base_url}/${id}`);
}

export const importCustomers = (data: object) => {
  return postFormData(`${base_url}/import`, data);
};
